import {useContext, useEffect, useState, useRef} from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import {urlValue, unfolder, validContext, useTranslate} from '../lib'
import logo1 from '../logos/ai-nesting-studio.svg';
import logo2 from '../logos/ai-nesting-studio-2.svg';
import icon_home from '../images/home.svg'
import icon_management_access from '../images/management_access.png'
import icon_manual from '../images/manual.svg'
import icon_bell from '../images/bell-white.svg'
import icon_minimize from '../images/minimize-white.svg'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import '../styles/titleBar.scss'
import LanguageSelector from './LanguageSelector';
import ReactModal from 'react-modal';
import { renderAsync } from 'docx-preview';

export default function TitleBar() {
  const [isValid, setIsValid] = useContext(validContext)
  const navigate = useNavigate()
  const { instance } = useMsal()
  const { name, last_name } = JSON.parse(localStorage.getItem('infoUser')) || {
    id: undefined,
  }
  const user = localStorage.getItem('hashInfo') != null
    ? unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')
    : {};
  const [notifications, setNotifications] = useState([]);
  const [showList, setShowList] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [docLoading, setDocLoading] = useState(false);
  const [docBlob, setDocBlob] = useState(null);
  const [renderKey, setRenderKey] = useState(0);
  const docViewerRef = useRef(null);
  const { t } = useTranslate();
  const logos = {
    'ai-nesting-studio.svg': logo1,
    'ai-nesting-studio-2.svg': logo2,
  };

  const logout = e => {
    localStorage.clear()
    sessionStorage.clear()
    setIsValid(false)
    instance.logoutPopup().catch(error => console.log(error))
    
  }
  function delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  
  useEffect(() => {
    ReactModal.setAppElement('#root');
    getNotifications();
    fetchCustomization();
  }, []);

  const getNotifications = async () => {
    try {
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
      const res = await axios.get(`${urlValue}/studio/release-notification`, {
        headers: { 
          user: id, 
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true
      });
      setNotifications(res.data.slice(0, 20));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCustomization = async () => {
    try {
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const res = await axios.get(`${urlValue}/studio/campaign-interface-customizations/user-last-campaign/${user.id}`, {
        headers: { user: user.id, 'access-token': token }
      });
      
      if (res.data && res.data.customization) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 días
        document.cookie = `campaign_customization=${encodeURIComponent(JSON.stringify(res.data.customization))};expires=${expires.toUTCString()};path=/`;
      }
    } catch (error) {
      console.error('No se pudo obtener la personalización de campaña:', error);
    }
  };

  const openNotification = async (n) => {

    if (n.is_unread) {
      await markAsMaximized(n.id);
    }

    setSelectedNotification(n);
    setModalOpen(true);
    setDocLoading(false);
    setDocBlob(null);
    
    if (n.file_url) {
      try {
        const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
        const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
        
        // Para documentos Word, renderizar con docx-preview
        if (n.file_name?.endsWith('.docx')) {
          const response = await axios.get(
            `${urlValue}/studio/notification-files/by-key?key=${encodeURIComponent(n.file_url)}`,
            {
              headers: {
                user: id,
                'access-token': token,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,
              responseType: 'blob'
            }
          );
          
          console.log('Documento descargado, blob size:', response.data.size);
          
          // Crear blob para la descarga
          const blobUrl = URL.createObjectURL(response.data);
          setFileUrl(blobUrl);
          
          // Establecer loading primero para mostrar el contenedor
          setDocLoading(true);
          
          // Guardar el blob para renderizar después
          setDocBlob(response.data);
          
          // Esperar más tiempo para que el modal y el contenedor estén completamente renderizados
          setTimeout(async () => {
            console.log('Verificando docViewerRef.current:', docViewerRef.current);
            if (docViewerRef.current) {
              try {
                console.log('Iniciando renderizado del documento...');
                
                await renderAsync(response.data, docViewerRef.current, null, {
                  className: 'docx-preview-container',
                  inWrapper: true,
                  ignoreWidth: false,
                  ignoreHeight: false,
                  ignoreFonts: false,
                  breakPages: true,
                  ignoreLastRenderedPageBreak: true,
                  experimental: false,
                  trimXmlDeclaration: true,
                  useBase64URL: false,
                  renderChanges: false,
                  renderHeaders: true,
                  renderFooters: true,
                  renderFootnotes: true,
                  renderEndnotes: true
                });
                
                console.log('Documento renderizado exitosamente');
                setDocLoading(false);
              } catch (error) {
                console.error('Error rendering document:', error);
                setDocLoading(false);
              }
            } else {
              console.error('docViewerRef.current no está disponible');
              setDocLoading(false);
            }
          }, 300);
        } else {
          // Para videos y otros archivos, creamos un blob local
          const response = await axios.get(
            `${urlValue}/studio/notification-files/by-key?key=${encodeURIComponent(n.file_url)}`,
            {
              headers: {
                user: id,
                'access-token': token,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,
              responseType: 'blob'
            }
          );
          
          const blobUrl = URL.createObjectURL(response.data);
          setFileUrl(blobUrl);
        }
      } catch (error) {
        console.error('Error loading file:', error);
        setFileUrl(null);
        setDocLoading(false);
        setDocBlob(null);
      }
    } else {
      setFileUrl(null);
      setDocBlob(null);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedNotification(null);
    if (fileUrl) {
      URL.revokeObjectURL(fileUrl);
      setFileUrl(null);
    }
    setDocLoading(false);
    setDocBlob(null);
    setRenderKey(prev => prev + 1); // Forzar re-render del contenedor
  };

  const downloadDocument = async () => {
    if (!selectedNotification?.file_url) return;
    
    try {
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
      
      const response = await axios.get(
        `${urlValue}/studio/notification-files/by-key?key=${encodeURIComponent(selectedNotification.file_url)}`,
        {
          headers: {
            user: id,
            'access-token': token,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
          responseType: 'blob'
        }
      );
      
      const blobUrl = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = selectedNotification.file_name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const markAsMaximized = async (notificationId) => {
    try {
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;

      await axios.post(
        `${urlValue}/studio/release-notification/${notificationId}/mark-maximized`,
        {},
        {
          headers: {
            user: id,
            'access-token': token,
            'X-CSRF-Token': csrfToken,
          },
          withCredentials: true,
        }
      );

      setNotifications(prev =>
        prev.map(n =>
          n.id === notificationId
            ? { ...n, is_unread: false }
            : n
        )
      );

    } catch (error) {
      console.error('markAsMaximized error:', error);
    }
  };

  return (
    <>
      <header style={{
          boxShadow: '0px 3px 6px #00000029',
      }}>
        <Link to={'/'} id='link-logo-main'>
            {(() => {
              const getCookie = (name) => {
                const cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
                return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : null;
              };

              const customization = getCookie('campaign_customization');
              const selectedLogo = customization?.logo || 'ai-nesting-studio.svg';
              const logoToUse = logos[selectedLogo] || logo1;

              return (
                <img id='home1-tp' className="logo" src={logoToUse} alt="Logo" />
              );
            })()}
            <Tooltip anchorId="home1-tp" content={t('common.goToHome')} place="top" />
        </Link>
        <div id='con-header-options' className="header-options">
            <div id='con-header-links' className="d-flex flex-row align-items-center">
                <Link id='home-tp' to={`/`} style={{marginRight: 15}}>
                    <div><img src={icon_home} style={{width: 30}} alt="Bell Icon" /></div>
                </Link>
                <Tooltip style={{fontSize: 13, maxWidth: 160}}
                    anchorId="home-tp" content={t('common.goToHome')} place="top" />
                {/* className='buttonH' */}
                <Link id='project-access' to={'/project-access'} style={{marginRight: 15}}>
                  <div><img src={icon_management_access} style={{width: 30}} alt="Bell Icon" /></div>
                </Link>
                <Tooltip anchorId="project-access" content={t('menu.projectAccess')} place="top" />
                <a download href='/icons/MANUALNESTING.pdf'  id='guide-tp' to={`.`} style={{marginRight: 15}}>
                    <div><img src={icon_manual} style={{width: 30}} alt="Gear Icon" /></div>
                </a>
                <Tooltip style={{fontSize: 13, maxWidth: 200}}
                    anchorId="guide-tp" content={t('menu.downloadUserManual')}  place="top" />                
                <Tooltip style={{fontSize: 13, maxWidth: 160}} anchorId="report-tp" content={t('reports.reports')}  place="top" />
                <div onClick={()=>{logout()}} id='logout-tp' to={`/project-reports`} style={{marginRight: 15, cursor: "pointer"}}>
                    <div><img src='/icons/logout-icon.svg' style={{width: 30}} alt="Gear Icon" /></div>
                </div>
                <Tooltip anchorId="logout-tp" content={t('menu.logout')}  place="top" />
            </div>
            <div style={{marginRight: 15}}>
                <LanguageSelector className="header-language-selector" />
            </div>
            <div className="d-flex flex-column" style={{marginLeft: 5}}>
              <div style={{fontWeight: 'bold', fontSize: 16, color: '#707070', whiteSpace: 'nowrap', fontFamily: 'principal-font'}}>
                  {user.name + ' ' + user.last_name}
              </div>
              <div style={{fontSize: 15, marginTop: -5, color: '#707070', fontFamily: 'principal-font-light'}}>
                  {user.role === 1 ? t('common.admin') : ''}
                  {user.role === 2 ? t('common.manager') : ''}
                  {user.role === 3 ? t('common.editor') : ''}
                  {user.role === 4 ? t('common.reader') : ''}
              </div>
            </div>

            {/*<div className="userIcon"></div>*/}
            {/*<div className="userInfo">*/}
            {/*    <p className="name">{name}</p>*/}
            {/*    <p className="title">{last_name}</p>*/}
            {/*</div>*/}
            {/*<div className="logout ml-3" onClick={logout}>*/}
            {/*    <img src="/icons/logout.png" alt="Logout" />*/}
            {/*</div>*/}
        </div>
      </header>

      {/* Botón flotante */}
      <div style={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        zIndex: 999,
      }}>
        <button
          style={{
            position: 'relative',
            padding: '10px 10px',
            borderRadius: 30,
            backgroundColor: '#0038A8',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          }}
          onClick={() => setShowList(!showList)}
        >
          <img
            src={showList ? icon_minimize : icon_bell}
            alt="toggle"
            style={{ width: 20, height: 20 }}
          />

          {notifications.some(n => n.is_unread) && (
            <span
              style={{
                position: 'absolute',
                top: -4,
                right: -4,
                backgroundColor: '#D32F2F',
                color: '#fff',
                borderRadius: '50%',
                width: 16,
                height: 16,
                fontSize: 11,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: '16px',
              }}
            >
              !
            </span>
          )}

        </button>

        {showList && (
          <div style={{
            marginTop: 10,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: 10,
            maxHeight: 300,
            width: 250,
            overflowY: 'auto',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            padding: 10
          }}>
            {/*<h4 style={{ margin: '5px 0', fontSize: 16 }}>Últimas 20</h4>*/}
            {notifications.length === 0 ? (
              <p style={{ fontSize: 14 }}>{t('menu.noNotification')} </p>
            ) : (
              notifications.map((n, idx) => (
                <div key={idx} style={{
                  padding: '10px 0',
                  borderBottom: '1px solid #eee',
                  fontSize: 14
                }}>
                  <div style={{display: 'flex', flexDirection:'row', justifyContent: 'space-between'}}>
                    <span style={{fontSize: 11, color: '#4d4d4d'}}>
                      <strong>
                        {n.title}
                      </strong>
                    </span><br />
                    <button
                      onClick={() => openNotification(n)}
                      title={t('common.maximize') || 'Maximizar'}
                      style={{
                        flexShrink: 0,
                        width: 32,
                        height: 32,
                        borderRadius: 6,
                        border: '1px solid #dcdcdc',
                        background: '#fff',
                        cursor: 'pointer',
                        textAlign: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        position: 'relative',
                      }}
                    >
                      <div style={{margin: 'auto'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                          width="22" height="22" aria-hidden="true">
                          <path d="M5 9V5h4M15 19h4v-4" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" />
                          <path d="M9 5H5m0 0v4M19 15v4m0 0h-4" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </div>

                      {n.is_unread && (
                        <span
                          style={{
                            position: 'absolute',
                            top: -5,
                            right: -5,
                            backgroundColor: '#D32F2F',
                            color: '#fff',
                            borderRadius: '50%',
                            width: 16,
                            height: 16,
                            fontSize: 11,
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: '16px',
                            zIndex: 2,
                          }}
                        >
                          !
                        </span>
                      )}

                    </button>
                  </div>
                  
                  
                  <span style={{fontSize: 11, color: '#4d4d4d'}}>{n.description}</span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1000 },
          content: {
            maxWidth: selectedNotification?.file_url && (selectedNotification?.file_name?.endsWith('.mp4') || selectedNotification?.file_name?.endsWith('.docx')) ? '900px' : '600px',
            width: '90%',
            maxHeight: '90vh',
            inset: '50% auto auto 50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '12px',
            padding: '20px',
            border: '1px solid #e6e6e6',
            overflow: 'auto'
          }
        }}
        contentLabel="Notification detail"
      >
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <h3 style={{margin: 0}}>{selectedNotification?.title}</h3>
          <button onClick={closeModal} style={{border: 'none', background: 'transparent', fontSize: 20, cursor: 'pointer'}}>×</button>
        </div>
        <div style={{marginTop: 10, fontSize: 14, color: '#444'}}>
          {selectedNotification?.description}
        </div>
        
        {/* Mostrar archivo si existe */}
        {selectedNotification?.file_url && fileUrl && (
          <div style={{marginTop: 20}}>
            {selectedNotification?.file_name?.endsWith('.mp4') ? (
              // Si es un video, mostrarlo con un reproductor
              <div style={{marginTop: 15}}>
                <h4 style={{fontSize: 14, marginBottom: 10, color: '#666'}}>{t('common.attachedVideo')}:</h4>
                <video 
                  controls 
                  style={{width: '100%', maxHeight: '400px', borderRadius: '8px'}}
                >
                  <source src={fileUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : selectedNotification?.file_name?.endsWith('.docx') ? (
              // Si es un documento Word, mostrarlo con docx-preview
              <div style={{marginTop: 15}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
                  <h4 style={{fontSize: 14, margin: 0, color: '#666'}}>{t('common.attachedDocument')}:</h4>
                  <button
                    onClick={downloadDocument}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#0038A8',
                      color: 'white',
                      borderRadius: '6px',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: 13,
                      fontWeight: 'bold'
                    }}
                  >
                    {t('common.download')}
                  </button>
                </div>
                <div 
                  key={renderKey}
                  style={{
                    width: '100%', 
                    minHeight: '500px',
                    maxHeight: '600px',
                    overflowY: 'auto',
                    overflowX: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',
                    position: 'relative'
                  }}
                >
                  <div 
                    ref={docViewerRef}
                    style={{
                      padding: '20px',
                      minHeight: '460px'
                    }}
                    className="docx-viewer-container"
                  />
                  {docLoading && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f9f9f9',
                      zIndex: 10
                    }}>
                      <p style={{fontSize: 14, color: '#999'}}>Cargando documento...</p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        )}
        
        {/* Mostrar mensaje de carga si hay archivo pero aún no se cargó */}
        {selectedNotification?.file_url && !fileUrl && (
          <div style={{marginTop: 20, padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px', textAlign: 'center'}}>
            <p style={{fontSize: 14, color: '#b8a5a5ff'}}>Loading file...</p>
          </div>
        )}
      </ReactModal>
    </>
  )
}
